export default "__VITE_ASSET__CWRSRFk3__"